import { Parser } from '~/api';
import { ServerTemplate } from '~/api/models';
import RequestService from './request';

export interface WhmcsImportRow {
    pid: number;
    name: string;
    identifier: string | null;
    action: 'create' | 'update';
    existingTemplateId: string | null;
    // Request-shape payload echoed back on confirm; null when the row errored.
    payload: Record<string, unknown> | null;
    // Synthesised (unsaved) template for the preview modal; null when the row errored.
    template: ServerTemplate | null;
    warnings: string[];
    error: string | null;
}

export interface WhmcsImportFailure {
    index: number | string;
    name: string | null;
    errors: string[];
}

export interface WhmcsImportResult {
    created: number;
    updated: number;
    failures: WhmcsImportFailure[];
}

class WhmcsImportService {
    preview(data: { url: string }): Promise<WhmcsImportRow[]> {
        return RequestService.post('/server-templates/import/preview', data).then((res) =>
            (res.products ?? []).map(
                (row: Record<string, any>): WhmcsImportRow => ({
                    pid: row.pid,
                    name: row.name,
                    identifier: row.identifier ?? null,
                    action: row.action,
                    existingTemplateId: row.existing_template_id ?? null,
                    payload: row.payload ?? null,
                    template: row.template ? Parser.parse(row.template) : null,
                    warnings: row.warnings ?? [],
                    error: row.error ?? null,
                }),
            ),
        );
    }

    confirm(data: { items: Record<string, unknown>[] }): Promise<WhmcsImportResult> {
        return RequestService.post('/server-templates/import/confirm', data);
    }
}

export default new WhmcsImportService();
